export const ProjectRouting = [
  {
    path: "/maintenance/project",
    name: "maintenance-project-list",
    meta: { title: "维保项目" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-project" */ "@/views/maintenance/project/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/project/create",
    name: "maintenance-project-create",
    meta: { title: "新建维保项目", comName: "MaintenanceProjectFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-project" */ "@/views/maintenance/project/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/project/edit/:id",
    name: "maintenance-project-edit",
    meta: { title: "编辑维保项目", comName: "MaintenanceProjectFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-project" */ "@/views/maintenance/project/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/project/detail/:id",
    name: "maintenance-project-detail",
    meta: { title: "维保项目详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-project" */ "@/views/maintenance/project/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/project/flowPrint/:id",
    name: "maintenance-project-flow-print",
    meta: { title: "维保项目打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-project" */ "@/views/maintenance/project/flow-print/index.vue"
      ),
  },
];
